/* eslint-disable @typescript-eslint/no-explicit-any */

import { SharedAppConstants } from '@tock/shared-app-constants';
import { dashboard } from 'types';
import { map } from 'es-toolkit/compat';
import { safeToNumber } from '@tock/coretypes';
import protos from 'utils/protos';

const { Tag } = protos;

/**
 * Fetches all tags.
 * @returns {Object} A redux TockApi action.
 */
export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/config/tag',
      type: SharedAppConstants.TAGS_FETCH_ALL,
    },
  };
}

/**
 * Create a tag
 *
 * @param {Tag} tag The tag to create.
 * @returns {Object} A redux TockApi action.
 */
export function create(tag: dashboard.ITag): ApiAction {
  const request = Tag.fromObject(tag);
  return {
    TockApi: {
      postProto: '/business/config/tag',
      type: SharedAppConstants.TAG_ADD,
      request,
      toast: 'Tag added',
    },
  };
}

/**
 * Update a tag.
 *
 * @param {Tag} tag The tag to update.
 * @returns {Object} A redux TockApi action.
 */
export function update(tag: dashboard.Tag): ApiAction {
  const request = Tag.fromObject(tag);
  return {
    TockApi: {
      putProto: '/business/config/tag',
      type: SharedAppConstants.TAG_UPDATE,
      request,
      toast: 'Tag updated',
    },
  };
}

export function updateAll(tags: dashboard.Tag[]): ApiAction {
  const requests = map(tags, (tag) => ({
    method: 'PUT',
    path: '/business/config/tag',
    payload: Tag.fromObject(tag),
    requestType: Tag,
  }));

  return {
    TockApi: {
      batchProto: requests,
      type: SharedAppConstants.TAG_UPDATE_ALL,
    },
  };
}

/**
 * Update a tag priority
 *
 * @param {Number} id The id of the tag to update.
 * @returns {Object} A redux TockApi action.
 */
export function updateTagPriority(id: number): ApiAction {
  return {
    TockApi: {
      postProto: `/tag/priority/update/${id}`,
      type: SharedAppConstants.TAG_PRIORITY_UPDATE,
      toast: 'Updated tag priority',
    },
  };
}

/**
 * Remove a table.
 *
 * @param {Tag} tag The tag to remove.
 * @returns {Object} A redux TockApi action.
 */
export function remove(tag: any): ApiAction {
  return {
    TockApi: {
      deleteProto: `/business/config/tag/${safeToNumber(tag.id)}`,
      type: SharedAppConstants.TAG_REMOVE,
      request: tag,
      context: { deletedTag: tag },
      toast: 'Tag removed',
    },
  };
}

export function reorder(tags: any, draggedItemIndex: any, hoveredItemIndex: any): BaseTockAction {
  return {
    type: SharedAppConstants.TAG_REORDER,
    payload: {
      draggedItemIndex,
      hoveredItemIndex,
      tags,
    },
  };
}
